export const locale = {
  lang: "en-CA",
  data: {
    ERROR_503: {
      MAINTENANCE: "Maintenance",
      MESSAGE: "Well, you broke the internet!",
      CONTACT_US: "Contact us",
      SUB_MESSAGE: "Our servers are taking a quick coffee break ☕ — they’ll be back soon, promise!",
      HUMOROUS_TITLE: "Oops! The chef burned the service.",
      HUMOROUS_MESSAGE: "No panic, our technicians are already in the kitchen firing up the stove again.",
      AUTO_CHECK: "Trying again automatically in {{seconds}} seconds…",
      AUTO_CHECK_NOW: "Checking…",
      REPORT_PROBLEM: "Report this problem",
      BACK_PAGE: "Go back to the previous page",
      BACK_HOME_PAGE: "Go back to dashboard",
      GT2_SITE: "Go to www.gestiontraiteur.com",
      RETRY: "Retry now",
      RETRYING: "Checking...",
      SUBJECT: "Subject",
      SUCCESS_MESSAGE: "Your message was sent successfully!",
      CONTACT_MESSAGE: "While we have been automatically informed, We always appreciate a more detailed feedback. Please contact us",
    },
  },
};
